import { ArrowRight, Film, Drama, Landmark, Sparkles, Users } from 'lucide-react';
import { CATALOGUE, displayTitle } from '../data/website';
import { SectionHeading } from './SectionHeading';

const ICONS = { film: Film, drama: Drama, landmark: Landmark, people: Users, sparkles: Sparkles };
export const Experiences = ({ onDiscover }) => <section id="explore" className="experiences-section" data-testid="experience-preview-section">
  <div className="site-container">
    <SectionHeading id="experience-preview" eyebrow="GIRAFFE ENTERTAINMENT & EXPERIENCES" title="Our experiences">
      <a className="text-link" href="#what-we-do" data-testid="view-what-we-do">What we do<ArrowRight size={15} /></a>
    </SectionHeading>
    <div className="experience-grid" data-testid="experience-grid">
      {CATALOGUE.map(item => { const Icon = ICONS[item.icon]; return <button key={item.id} className="experience-tile" onClick={() => onDiscover(item)} data-testid={`experience-card-${item.id}`}>
        <div className="experience-image"><img src={item.image} alt={`Illustrative ${displayTitle(item.title)} imagery`} loading="lazy" /><span className="image-hover-arrow"><ArrowRight size={18} /></span></div>
        <div className="experience-caption"><Icon size={21} strokeWidth={1.25} /><div><h3>{displayTitle(item.title)}</h3><p>{item.category === 'Our flagship experience' ? 'Our flagship experience' : 'What we do'}</p></div></div>
      </button>; })}
    </div>
  </div>
</section>;